
import { RevButton } from '@ds/components/Button'
import { RevButtonRounded } from '@ds/components/ButtonRounded'
import { RevModal } from '@ds/components/Modal'
import { closeModal } from '@ds/components/ModalBase'
import { IconCheckInCircleFilled } from '@ds/icons/IconCheckInCircleFilled'
import { IconCross } from '@ds/icons/IconCross'

import { MODAL_NAMES } from '@config/constants'
import RecommendationCrossSell from '@recommendation/components/RecommendationCrossSell/RecommendationCrossSell.vue'
import { ROUTES } from '@router'
import { trackClick } from '@tracking/events'

import translations from './AddToCartModal.translations'

const MAX_PRODUCT_TITLE_LENGTH = 25

export default {
  components: {
    IconCheckInCircleFilled,
    RecommendationCrossSell,
    RevButton,
    RevButtonRounded,
    RevModal,
  },
  props: {
    title: {
      type: String,
      required: true,
    },

    listingId: {
      type: Number,
      required: true,
    },

    additionalListings: {
      type: Array,
      required: true,
    },
  },
  computed: {
    translations: () => translations,

    IconCross: () => IconCross,

    modalName: () => MODAL_NAMES.PRODUCT.ADD_TO_CART,

    headerTitle() {
      return this.$t(this.translations.title, {
        count: [this.listingId, ...this.additionalListings].length,
        product: this.truncate(this.title),
      })
    },
  },
  methods: {
    closeModal,
    truncate: (input) =>
      input.length > MAX_PRODUCT_TITLE_LENGTH
        ? `${input.substring(0, MAX_PRODUCT_TITLE_LENGTH)}...`
        : input,

    handleAddToCartRedirect() {
      trackClick({
        name: 'go_to_cart',
        zone: 'add_to_cart_modal',
      })

      this.$navigation.push({
        type: 'internal',
        name: ROUTES.CHECKOUT.CART,
      })
    },

    handleContinue() {
      trackClick({
        name: 'continue_shopping',
        zone: 'add_to_cart_modal',
      })

      closeModal(this.modalName)
    },

    handleClose() {
      trackClick({
        name: 'dismiss_atc_modal',
        zone: 'add_to_cart_modal',
      })
      closeModal(this.modalName)
    },
  },
}
